import CommonTimePicker from "Components/Common/CommonTimePicker";

const CustomTimePicker = ({ label, ...props }) => {
  return (
    <div className="custom_select_date">
      <label htmlFor="">{label}</label>

      <CommonTimePicker {...props} />
    </div>
  );
};

export default CustomTimePicker;
